import React from 'react';

function ResponseTable({ response }) {
  if (!response) return null;
  if (!Array.isArray(response) || response.length === 0) {
    return <span>{JSON.stringify(response)}</span>;
  }
  const keys = Object.keys(response[0]);
  return (
    <div>
      <div className="response-table-title">Upload Report</div>
      <div className="response-table-grid" role="table">
        {/* Data rows */}
        {response.map((row, idx) =>
          keys.map((key) => (
            <span key={key + idx} className="response-table-cell" role="cell">
              {row[key]}
            </span>
          ))
        )}
      </div>
    </div>
  );
}

export default ResponseTable;
